<div class="tt-sidebar-attachments_header">
  <span>{{ 'Attachments' | transloco }}:</span>
  <button aria-label="Add attachment button" emphasis="minimal" size="icon" ttButton variant="primary" (click)="openAttachmentDialog()">
    <mat-icon [icon]="'circle-plus-filled'" [iconSize]="18" />
  </button>
</div>

<div class="tt-sidebar-attachments_list">
  @for (attachment of attachments; track attachment.id) {
    <tt-attachment-card
      [variant]="'editor'"
      [version]="attachment"
      (deleted)="deleteAttachment(attachment.id, attachment.displayName || attachment.originalName)"
      (downloaded)="downloadAttachment(attachment)" />
  }
</div>
